import { render } from "./DoctoresTable.vue?vue&type=template&id=18ba3471&scoped=true"
import script from "./DoctoresTable.vue?vue&type=script&lang=js"
export * from "./DoctoresTable.vue?vue&type=script&lang=js"

import "./DoctoresTable.vue?vue&type=style&index=0&id=18ba3471&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ba3471"]])

export default __exports__